<style lang="scss" scoped>
  $leftWidth: 220px;
  .content-part {
    .content-left {
      width: 0;
    }

    .content-right {
      > h3 {
        left: 0;
      }

      left: 0;
    }
  }

  .el-checkbox--upload {
    position: absolute;
    left: 100px;
    top: 0;
    display: block;
  }

  .waring-tag {
    position: absolute;
    top: 0;
    left: 70px;
    padding-left: 10px;
    margin-bottom: 5px;
  }
</style>
<template>
  <div>
    <div class="content-part">
      <div class="content-right min-gutter">
        <h3>整批出库</h3>
        <div class="hide-content show-content">
          <el-form ref="form" :rules="rules" :model="form"
                   label-width="120px" style="padding-right: 20px">
            <el-form-item label="货主" prop="sourceOrgId"
                          :rules="[{required: true, message: '请选择货主', trigger: 'change'}]">
              <org-select :remote-method="queryUpAllFactory" :placeholder="`请输入名称/拼音首字母缩写/系统代码搜索货主`"
                          v-model="form.sourceOrgId" :list="allOrgList"/>
            </el-form-item>
            <el-form-item label="往来单位" prop="businessOrgId"
                          :rules="[{required: true, message: '请选择往来单位', trigger: 'change'}]">
              <org-select :remote-method="queryBizOrgList" :placeholder="`请输入名称/拼音首字母缩写/系统代码搜索业务单位`"
                          v-model="form.businessOrgId" :list="bizOrgList" @change="setDirectOrgId"/>

            </el-form-item>
            <el-form-item label="订单号" prop="orderNo" :rules="[{required: true, message: '请输入订单号', trigger: 'blur'}]">
              <oms-input placeholder="请输入订单号" type="text" v-model="form.orderNo"></oms-input>
            </el-form-item>
            <el-form-item label="业务类型" prop="bizType" :rules="[{required: true, message: '请选择业务类型', trigger: 'change'}]">
              <el-select filterable placeholder="请选择业务类型" v-model="form.bizType">
                <el-option :key="item.key" :label="item.label" :value="item.key" v-for="item in outBizTypes"/>
              </el-select>
            </el-form-item>
            <el-form-item label="货品" prop="goodsId" :rules="[{required: true, message: '请选择货品', trigger: 'change'}]">
              <el-select placeholder="请输入名称搜索货品" v-model="form.goodsId" filterable remote
                         :remote-method="queryManageGoods" @change="goodsChange"
                         :clearable="true" popperClass="custom-select" @click.native.once="queryManageGoods('')">
                <el-option :label="item.name" :value="item.goodsId" :key="item.id" v-for="item in manageGoods">
                  <manage-goods-option :optionItem="item"/>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="批号" prop="batchNumberId" :rules="[{required: true, message: '请选择批号', trigger: 'change'}]">
              <el-select v-model="form.batchNumberId" filterable clearable remote
                         :remoteMethod="queryGoodsBatchNumber" placeholder="请输入批号名称搜索批号">
                <el-option v-for="item in goodsBatchNumberList" :value="item.id" :key="item.id"
                           :label="item.batchNumber"/>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit" :disabled="doing">保存
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {http,businessOrg} from '@/resources';
  import methodsMixin from '@/mixins/methodsMixin';

  export default {
    props: ['defaultIndex'],
    mixins: [methodsMixin],
    data() {
      return {
        form: {
          sourceOrgId: '',
          businessOrgId:'',
          directOrgId: '',
          orderNo:'',
          goodsId: '',
          bizType: '',
          batchNumberId: ''
        },
        bizOrgList:[],
        rules: {},
        doing: false
      };
    },
    computed: {
      outBizTypes: function () {
        let bizTypes = this.$getDict('bspBizType') || [];
        return bizTypes.filter(f => {
          return f.key.startsWith('2');
        });
      }
    },
    watch: {
      defaultIndex(val) {
        this.$refs.form.resetFields();
        this.resetForm();
        let org= JSON.parse(window.localStorage.getItem('org'));
        let tempOrg={
          id:org.id,
          name:org.name
        }
        this.form.sourceOrgId=org.id;
        this.allOrgList = [tempOrg];
      }
    },
    methods: {
      setDirectOrgId(val){
        if (!val) return;
        let list = this.bizOrgList.filter(v => v.id === val);
        if (list && list[0]) {
          this.form.directOrgId = list[0].businessOrgId;
        }
      },
      queryBizOrgList(query) {
        let params = {};
        if (typeof query === 'string') {
          params = {keyWord: query, deleteFlag: false,orgId:this.$store.state.user.userCompanyAddress}
        } else if (typeof query === 'object') {
          params = query;
        }
        businessOrg.query(params).then(res => {
          this.bizOrgList = res.data.list.map(m => ({
            id: m.id,
            businessOrgId: m.businessOrgId,
            name: m.businessOrgName,
            manufacturerCode: m.businessOrgManufacturerCode,
            creditCode: m.businessOrgCreditCode
          }));
        });
      },
      queryGoodsBatchNumber(query) {
        if (!this.form.goodsId)  return this.$notify.info({message: '请先选择货品'});
        return this.$http.post('/dhs-batch-number/pager', {goodsId: this.form.goodsId}, {
          params: {
            keyWord: query
          }
        }).then(res => {
          this.goodsBatchNumberList = res.data.list.filter(f => f.batchStatus !== '2');
        });
      },
      goodsChange(val) {
        this.form.batchNumberId = '';
        this.goodsBatchNumberList = [];
        if (!this.form.goodsId) return;
        this.queryGoodsNumber('form.goodsId')('');
      },
      queryManageGoods(query) {
        let params = {};
        if (typeof query === 'object') {
          params = query;
        } else {
          let user = this.$store.state.user;
          if (!user.userCompanyAddress) return;
          params = {
            orgId: user.userCompanyAddress,
            deleteFlag: false,
            keyWord: query,
            auditStatus: '1'
          };
        }
        return this.$http.get('/dhs-operation-goods', {params}).then(res => {
          this.manageGoods = res.data.list;
        });
      },
      resetForm() {
        this.form = {
          sourceOrgId: '',
          orderNo:'',
          directOrgId: '',
          goodsId: '',
          bizType: '',
          batchNumberId: ''
        };
      },
      onSubmit() {
        this.$refs['form'].validate((valid) => {
          if (!valid || this.doing) {
            return false;
          }
          let form = JSON.parse(JSON.stringify(this.form));
          this.doing = true;
          http.post('/code-biz/whole-batch-outbound', form).then(res => {
            this.$emit('refresh', {id: res.data});
            this.resetForm();
            this.doing = false;
          }).catch(e => {
            this.$notify.error({
              duration: 2000,
              message: e.response && e.response.data && e.response.data.msg || '保存失败'
            });
            this.doing = false;
          });
        });
      }
    }
  };
</script>
